import { Lead } from "@kanda-libs/ks-frontend-services";
import get from "lodash.get";
import { ORDER, SORTING } from "./constants";

export const sortByUpdatedAt = (data: Lead[], order: string) =>
  data.sort((data1, data2) => {
    const data1UpdatedAt =
      (get(data1, "metadata.updated_at") as unknown as string) || "";
    const data2UpdatedAt =
      (get(data2, "metadata.updated_at") as unknown as string) || "";

    if (order === ORDER.INVERSE)
      return (
        new Date(data1UpdatedAt).getTime() - new Date(data2UpdatedAt).getTime()
      );

    return (
      new Date(data2UpdatedAt).getTime() - new Date(data1UpdatedAt).getTime()
    );
  });

// Sorts the data according to sorting and order
export const sortData = (
  data?: Lead[],
  sorting?: string,
  order: string = ""
): Lead[] => {
  if (!data) return [];

  // If no jobs, return null to show the placeholder
  if (data.length === 0) return [];

  // If sorting is updated_at, return data sorted by updated at date
  if (sorting === SORTING.UPDATED_AT) return sortByUpdatedAt(data, order);

  return data;
};
